export default class RentalClass{
  constructor(){
    this.rateId = '';
    this.rentalLocationID = '';
    this.businessHoursPickup = '';
    this.businessHoursReturn = '';
    this.classCode = '';
    this.modelDesc = '';
    this.classDesc = '';
    this.rateCode = '';
    this.rateDescription = '';
    this.ratePlan = '';
    this.mileageUnit = '';
    this.currencyCode = '';
    this.rateAmount = '';
    this.freeMiles = '';
    this.perMileAmount = '';
    this.extraDayRate = '';
    this.extraDayFreeMiles = '';
    this.perHourCharge = '';
    this.rateAdjustment = '';
    this.classImageURL = '';
    this.totalCharges = '';
    this.isUpgrade = false;
  }

  setClass(cl){
    this.classCode = cl;
  }
  setModelDesc(md){
    this.modelDesc = md;
  }
  setRateId(ri){
    this.rateId = ri;
  }
  setTotalCharges(tc){
    this.totalCharges = tc;
  }
  setIsUpgrade(isUpgrade){
    this.isUpgrade = isUpgrade;
  }
}
